import { useAlerts } from "../../../context/AlertContext";


function Messages(){

    const time = new Date().getTime();
    const { maintenanceMessages } = useAlerts();
    //const msEpoch = time.getTime(); 
    const defined = (v) => v !== undefined && v !== null && v !== "";

    //alert(messages)

    if(!defined(maintenanceMessages)){
        //setError("Failed to Load Data")
        return(
            <>error</>
        )
    }

    return(<div> 
    
        <div className='Index'>
            <div id='table' style={{width: '70%', padding:'0px 10px 10px'}}>
                 <div id="banner-search">
                    <h4> Maintenance</h4>
                 </div>
                <thead>
                <tr>
                    <th>
                        <div className="form-text mt-2 text-muted">
                            Message
                        </div>
                    </th>
                </tr>
                </thead>
                <tbody>
                {maintenanceMessages.map((message) => (
                    <tr>
                    <td><hr />{message}</td>
                    </tr>
                ))}
                </tbody>
            </div>
        </div>
       
    </div>)
}


export default Messages;